import { Typography } from '@mui/material';
import LegalPage from '../../components/common/LegalPage';

// Content from New Website.docx, "Page Title 'California Consumer Privacy Policy (CCPP)'".
export default function Ccpp() {
  return (
    <LegalPage title="California Consumer Privacy Notice">
      <Typography variant="body1">
        This California Consumer Privacy Notice supplements the information contained in Cherry Creek Mortgage,
        LLC&rsquo;s Privacy Policy and applies solely to California residents (&ldquo;Consumers&rdquo;).
      </Typography>

      <Typography variant="body1">
        The California Consumer Privacy Act of 2018, as amended by the California Privacy Rights Act (collectively,
        &ldquo;CCPA&rdquo;), provides California residents with specific rights regarding their personal
        information. This Notice describes those rights and explains how California residents may exercise them.
      </Typography>

      <Typography variant="h5">Scope of This Notice</Typography>
      <Typography variant="body1">
        Under CCPA, California residents have certain rights regarding personal information that is collected,
        used, disclosed, or sold by a business. These rights apply only to California residents and only to
        personal information subject to CCPA. Not all personal information collected by Cherry Creek Mortgage, LLC
        is covered by CCPA.
      </Typography>

      <Typography variant="h5">California Licensing Disclosure</Typography>
      <Typography variant="body1">
        Cherry Creek Mortgage, LLC is licensed by the California Department of Financial Protection and Innovation
        (DFPI) under the California Residential Mortgage Lending Act. CA DFPI License Number: 4130289
      </Typography>

      <Typography variant="h5">Information Exempt from CCPA</Typography>
      <Typography variant="body1">Personal information collected under the following laws is exempt from CCPA:</Typography>
      <Typography variant="body1" component="ul">
        <li>Gramm-Leach-Bliley Act (Public Law 106-102)</li>
        <li>Fair Credit Reporting Act (15 U.S.C. § 1681 et seq.)</li>
        <li>California Financial Information Privacy Act (Division 1.4, Section 4050)</li>
      </Typography>
      <Typography variant="body1">
        Because Cherry Creek Mortgage, LLC collects personal information in connection with mortgage lending
        activities, much of the personal data we collect is governed by these federal and state financial privacy
        laws and is therefore not subject to CCPA consumer rights, including the rights to know, delete, or
        opt-out.
      </Typography>

      <Typography variant="h5">Information We Collect</Typography>
      <Typography variant="body1">
        Cherry Creek Mortgage, LLC collects information that identifies, relates to, describes, references, or is
        reasonably capable of being associated with a particular consumer (&ldquo;Personal Information&rdquo;). Not
        all Personal Information we collect is subject to CCPA. Any Personal Information that is subject to CCPA
        is collected for legitimate business purposes, including mortgage origination, underwriting, servicing,
        compliance, fraud prevention, and customer service. We may have collected the following categories of
        Personal Information from California consumers within the past 12 months. Note: Cherry Creek Mortgage, LLC
        does not sell Personal Information as defined by CCPA. We may, however, share Personal Information with
        non-affiliated insurance providers or other financial institutions as permitted by law so that they may
        offer products or services of potential interest to you.
      </Typography>

      <Typography variant="h5">Consumer Rights Under CCPA</Typography>
      <Typography variant="body1">
        <strong>Right to Know:</strong> You have the right to request that Cherry Creek Mortgage, LLC disclose the
        categories and specific pieces of Personal Information we have collected, used, or disclosed about you
        during the preceding 12 months, to the extent required by law.
      </Typography>
      <Typography variant="body1">
        <strong>Right to Delete:</strong> You have the right to request deletion of certain Personal Information
        collected about you. This right does not apply when retention of the information is necessary to comply
        with legal obligations, complete a transaction, prevent fraud, or for other lawful business purposes.
      </Typography>
      <Typography variant="body1">
        <strong>Right to Opt Out of Sale or Sharing:</strong> You have the right to opt out of the sale or sharing
        of Personal Information. Cherry Creek Mortgage, LLC does not sell Personal Information for marketing
        purposes.
      </Typography>
      <Typography variant="body1">
        <strong>Right to Non-Discrimination:</strong> You have the right not to receive discriminatory treatment
        for exercising any rights afforded to you under CCPA.
      </Typography>

      <Typography variant="h5">Exercising Your California Privacy Rights</Typography>
      <Typography variant="body1">
        California consumers may submit requests to exercise applicable privacy rights through our online form. We
        may need to verify your identity before processing certain requests, as permitted or required by law.
      </Typography>

      <Typography variant="h5">Updates to This Notice</Typography>
      <Typography variant="body1">
        This California Consumer Privacy Notice may be updated periodically to reflect changes to applicable laws
        or our information practices. The most current version will be posted on our website.
      </Typography>
    </LegalPage>
  );
}
